import { Stack, styled, TextField, useTheme } from '@mui/material'
import { IconButton } from 'ComponentLibrary'
import { ChangeEventHandler, FocusEventHandler } from 'react'

import { MinusCircle, PlusCircle } from 'react-feather'
export type SmallNumberInputProps = {
    label: string
    error?: boolean
    // Disables text input and buttons
    disabled?: boolean
    // Disables only text input
    disableTyping?: boolean
    required?: boolean
    minValue?: number
    maxValue?: number
    value: number
    setValue?: (val: number) => void
    onChange?: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>
    onBlur?: FocusEventHandler<HTMLTextAreaElement | HTMLInputElement>
    onFocus?: FocusEventHandler<HTMLTextAreaElement | HTMLInputElement>
}

function SmallNumberInput({
    label,
    value,
    onChange,
    onBlur,
    onFocus,
    error,
    setValue,
    disabled,
    disableTyping,
    minValue,
    maxValue,
}: SmallNumberInputProps) {
    const theme = useTheme()
    const onClickPlus = () => {
        setValue?.(value + 1)
    }
    const onClickMinus = () => {
        setValue?.(value - 1)
    }
    const isAtMinValue = minValue !== undefined && value === minValue
    const isAtMaxValue = maxValue !== undefined && value === maxValue
    return (
        <Stack direction="row">
            {setValue && (
                <StyledIconButton
                    disabled={disabled || isAtMinValue}
                    icon={!isAtMinValue && <MinusCircle />}
                    size={'small'}
                    onClick={onClickMinus}
                    ariaLabel={`${label} verringern`}
                />
            )}
            <StyledTextField
                id={`small-number-field-${label}`}
                onChange={onChange}
                disabled={disabled || disableTyping || (onChange === undefined && onBlur === undefined)}
                onBlur={onBlur}
                onFocus={onFocus}
                error={!!error}
                value={value !== null && value !== undefined ? value : ''}
                inputProps={{
                    'aria-label': label,
                    style: {
                        padding: 0,
                        borderRadius: '8px',
                        height: 36,
                        width: 36,
                        border: `1px solid ${error ? theme.palette.danger.main : theme.palette.customtext.black23}`,
                        textAlign: 'center',
                    },
                }}
            />
            {setValue && (
                <StyledIconButton
                    disabled={disabled || isAtMaxValue}
                    icon={!isAtMaxValue && <PlusCircle />}
                    size={'small'}
                    onClick={onClickPlus}
                    ariaLabel={`${label} erhöhen`}
                />
            )}
        </Stack>
    )
}

const StyledTextField = styled(TextField)`
    & .MuiOutlinedInput-notchedOutline {
        border: none;
    }
`
const StyledIconButton = styled(IconButton)`
    padding: ${({ theme }) => theme.spacing(2)};
`

export default SmallNumberInput
